// extracted by mini-css-extract-plugin
module.exports = {"Password":"RegistrationForm_Password__4iVkb","Error":"RegistrationForm_Error__3wQeD","RegisterButton":"RegistrationForm_RegisterButton__1Sdcf"};